module.exports = __webpack_public_path__ + "static/media/jira.432713a8.svg";